/** Read a capability from a URL fragment. Fragments never reach the server or ALB logs. */
export function readCapabilityFromFragment(hash: string, name: string): string {
  if (!hash.startsWith("#")) return "";
  const fragment = hash.slice(1);
  return new URLSearchParams(fragment).get(name)?.trim() ?? "";
}

export const RESET_TOKEN_SESSION_KEY = "mot_reset_token";
export const VERIFY_EMAIL_TOKEN_SESSION_KEY = "mot_verify_email_token";
const SUPPORT_GUEST_LOCAL_KEY = "mot_support_guest";

type CapabilityWindow = Pick<Window, "location" | "history" | "localStorage" | "sessionStorage">;

/** Capture sensitive fragments before monitoring or analytics initialize, then remove them from the URL. */
export function captureSensitiveCapabilityFragment(browser: CapabilityWindow): void {
  const pageToken = readCapabilityFromFragment(browser.location.hash, "token");
  const guestToken = readCapabilityFromFragment(browser.location.hash, "guestToken");
  if (!pageToken && !guestToken) return;

  if (pageToken && browser.location.pathname === "/reset-password") {
    try { browser.sessionStorage.setItem(RESET_TOKEN_SESSION_KEY, pageToken); } catch { /* storage unavailable */ }
  }

  if (pageToken && browser.location.pathname === "/verify-email") {
    try { browser.sessionStorage.setItem(VERIFY_EMAIL_TOKEN_SESSION_KEY, pageToken); } catch { /* storage unavailable */ }
  }

  if (guestToken) {
    const queryTicket = new URLSearchParams(browser.location.search).get("id")?.trim();
    const pathTicket = browser.location.pathname.match(/^\/help\/([0-9a-f-]{36})\/?$/i)?.[1];
    const ticketId = queryTicket || pathTicket;
    if (ticketId) {
      try {
        const raw = browser.localStorage.getItem(SUPPORT_GUEST_LOCAL_KEY);
        const previous = raw ? JSON.parse(raw) as { email?: string } : {};
        browser.localStorage.setItem(SUPPORT_GUEST_LOCAL_KEY, JSON.stringify({ ...previous, ticketId, guestToken }));
      } catch { /* storage unavailable */ }
    }
  }

  browser.history.replaceState(null, "", `${browser.location.pathname}${browser.location.search}`);
}
